module.exports = __webpack_public_path__ + "static/media/distance.74ec4d87.svg";